<div class="container">
  <ng-container *ngIf="!loadIndicator; else loading">
<div class="logo_image">
  <img *ngIf="globalService.langChosen === 'ar'"  src="assets/img/tecno-cup-ksa/Tournments-icon.png" class="img-responsive">
  <img *ngIf="globalService.langChosen === 'en'" src="../../../../../assets/img/tecno-cup-ksa/tournament-eng.png" class="img-responsive">  </div>
  <div class="tournament-container">
    <ng-container *ngIf="tournaments && tournaments.length > 0; else nodata">

      <ng-container *ngFor="let tournament of tournaments" >
        <app-tournaments-reusable [tournament]="tournament" [backgroundImageBody]="'linear-gradient(90deg, rgba(22,191,253,1) 0%, rgba(2,100,250,1) 55%)'"
                                  [colorBody]="'#ffffff'" [direction]="'ar'" [fillColor]="'#ffffff'">
        </app-tournaments-reusable>
      </ng-container>
    </ng-container>
  </div>
  </ng-container>
    <ng-template #nodata>
      <div class="container">
        <div class=" no-data">
          <h2>{{globalService.customLang.no_tournaments_yet}}</h2>
        </div>
      </div>
    </ng-template>
  </div>
  <ng-template #loading>
    <app-loading-indicator></app-loading-indicator>
  </ng-template>
